import OrderSettingsLayout from 'menus/layouts/OrderSettingsLayout';
import MenuContainer from 'menus/containers/MenuContainer';
import OrderSettingRouteContainer from 'menus/containers/OrderSettingRouteContainer';
import MenuItemDetailContainer from 'menus/containers/MenuItemDetailContainer';
import MenuItemPageLayout from 'menus/layouts/MenuItemLayout';
import MenuLayout from 'menus/layouts/MenuLayout';

import {
  MENU_BASE,
  MENU_ORDER_SETTING,
  MENU_ITEM_DETAIL
} from 'menus/constants/paths';

const routes = [
  {
    path: MENU_BASE,
    exact: true,
    Component: MenuContainer,
    Layout: MenuLayout
  },
  {
    path: MENU_ORDER_SETTING,
    exact: true,
    Component: OrderSettingRouteContainer,
    Layout: OrderSettingsLayout
  },
  {
    path: MENU_ITEM_DETAIL,
    exact: true,
    Component: MenuItemDetailContainer,
    Layout: MenuItemPageLayout
  }
];

export default routes;
